import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** Download booking invoice PDF (customer endpoint) */
export const useDownloadMyBookingInvoicePdfMutation = () =>
  useMutation({
    mutationFn: async (bookingId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(`/me/bookings/${bookingId}/invoice-pdf`, {
        responseType: 'blob',
      })
      return response.data
    },
  })
